<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-rss-subscription`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.8 1.4a2 2 0 012 2v40.628a2 2 0 01-2.959 1.755L24.76 38.09a2 2 0 00-1.918 0L8.76 45.783a2 2 0 01-2.96-1.755V3.4a2 2 0 012-2h32zm-2 4h-28v35.256l11.123-6.077a6 6 0 015.754 0L37.8 40.656V5.4zM17 11c8.837 0 16 7.163 16 16 0 .678-.042 1.345-.124 2h-4.042c.11-.65.166-1.318.166-2 0-6.525-5.209-11.834-11.695-11.996L17 15v-4zm0 7a9 9 0 018.777 11h-4.193a5 5 0 00-4.367-6.996L17 22v-4zm0 7a2 2 0 110 4 2 2 0 010-4z"/></svg>
</template>
<script>

export default {
  name: 'IconRssSubscription',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
